import React, { useEffect } from 'react';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { TextField } from 'components/TextField/TextField';

interface DeleteAccountConfirmInputProps {
  toggleDeleteEnabled: (isEnabled: boolean) => void;
}

export const DeleteAccountConfirmInput: React.FC<DeleteAccountConfirmInputProps> = ({
  toggleDeleteEnabled,
}) => {
  const { translation } = useTranslationContext();

  useEffect(() => () => toggleDeleteEnabled(false), [toggleDeleteEnabled]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const deleteText = translation('delete_account_action').toLocaleLowerCase();

    if (inputValue.trim().toLocaleLowerCase() === deleteText) {
      toggleDeleteEnabled(true);
      return;
    }
    toggleDeleteEnabled(false);
  };

  return (
    <TextField
      id="delete-account-confirm-input"
      className="delete-account__confirm-input"
      placeholder={translation('delete_account_action')}
      onChange={handleChange}
    />
  );
};
